import type { Grenade, Side } from "@69ly/shared";

/**
 * The map markers drawn for 69LY (packages/ui/assets/grenades/markers, built by
 * packages/ui/scripts/build-markers.py from the impact and launch drawings), as
 * hashed asset URLs: where a grenade lands (impact) and where it is thrown from
 * (launch), per side, and their selected look.
 */
const files = import.meta.glob("../../../../packages/ui/assets/grenades/markers/*/*.webp", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

/** Where it lands, where it is thrown from, or the landing drawing alone (no disc) for tight spots. */
export type MarkerKind = "impact" | "launch" | "glyph";

export function markerUrl(kind: MarkerKind, grenade: Grenade, side: Side, selected = false): string {
  const name = `/${kind}/${grenade}-${side}${selected ? "-selected" : ""}.webp`;
  return Object.entries(files).find(([path]) => path.endsWith(name))?.[1] ?? "";
}
